__turbopack_context__.v({
  "markdown": "PdpDealsBannerList-module-scss-module__PcmUsW__markdown",
});
